module.exports = "/_next/static/images/prezzee_logo-ceb34219a54086df47fcf0165a24caa3.svg";